// Dialog: scelta cosa fare con la foto scattata (OCR o salva soltanto).
import { Scan, Image as ImageIcon, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

const FotoSceltaDialog = ({ open, onOpenChange, fotoBase64, ocrLoading, uploadingPhoto, onConferma }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm mx-4 rounded-3xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground">Cosa vuoi fare?</DialogTitle>
          <DialogDescription className="sr-only">Scegli se leggere automaticamente l’etichetta o conservare soltanto la foto.</DialogDescription>
        </DialogHeader>
        {fotoBase64 && <img src={fotoBase64} alt="Preview" className="w-full h-32 object-cover rounded-xl" />}
        <div className="space-y-2">
          <Button onClick={() => onConferma("scan")} disabled={ocrLoading || uploadingPhoto} className="w-full bg-primary hover:bg-primary/90 text-white" data-testid="ocr-scan-btn">
            {ocrLoading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Scan className="h-4 w-4 mr-2" />}
            {ocrLoading ? "Scansione..." : "Scansiona dati (OCR)"}
          </Button>
          <Button onClick={() => onConferma("save")} disabled={ocrLoading || uploadingPhoto} variant="outline" className="w-full border-border text-foreground" data-testid="save-photo-only-button">
            {uploadingPhoto ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ImageIcon className="h-4 w-4 mr-2" />}
            Salva solo foto
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FotoSceltaDialog;
